import React from "react";
import "./PublicationCard.css";
import { Fade } from "react-reveal";
import { Link, NavLink } from "react-router-dom";

export default function PublicationCardLink({ pub, theme }) {
  return (
    <div
      className="publication-card-div"
      style={{ backgroundColor: theme.highlight }}
    >
      <Fade bottom duration={2000} distance="40px">
        <NavLink to={pub.path} className="link" tag={Link}>
          <div key={pub.id}>
            <div className="publication-name-div">
              <p className="publication-name" style={{ color: theme.text }}>
                {pub.name}
              </p>
            </div>
            <p
              className="publication-description"
              style={{ color: theme.text }}
            >
              {pub.description}
            </p>
            <div className="publication-details">
              <p
                className="publication-creation-date subTitle"
                style={{ color: theme.secondaryText }}
              >
                Published on {pub.createdAt.split("T")[0]}
              </p>
            </div>
          </div>
        </NavLink>
      </Fade>
    </div>
  );
}
